import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSnapshot } from 'valtio';

import { lightStore } from '../managers/globalState';

import '../../www/assets/css/light_toggle.css';
import CameraLightButtonOnSVG from '../../www/assets/images/camera_light_button_on.svg';
import CameraLightButtonOffSVG from '../../www/assets/images/camera_light_button_off.svg';


const LightToggle = ({ enabled, isMobile }) => {
	const { fill } = useSnapshot(lightStore.state);

	// Toggle light fill.
	const onClick = useCallback(() => {
		lightStore.setGlobalState({ fill: !fill });
	}, [fill]);

	const classes = `light-toggle no-select ${enabled ? '' : 'disabled'} ${fill ? '' : ' secondary'}`;
	let text;
	const is_arabic = window.config && window.config.acceptLanguage && window.config.acceptLanguage == 'ar';
	if(is_arabic){
		text = enabled ? 'على' : 'بعيدا';
	} else {
		text = enabled ? 'ON' : 'OFF';
	}

	return (
		<button type='button' aria-label='light-toggle' className={classes} value='light' onClick={onClick}>
			{fill ? <CameraLightButtonOffSVG /> : <CameraLightButtonOnSVG />}
			{isMobile && <label>{text}</label>}
		</button>
	);
};

LightToggle.propTypes = {
	enabled: PropTypes.bool,
	isMobile: PropTypes.bool
};

export default LightToggle;
